import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  cashRegister: "/cash-register",
  cashRegisterOpen: "/cash-register/open",
  cashRegisterClose: "/cash-register/close",
  cashRegisterChange: "/cash-register/change",
  cashRegisterWithdrawal: "/cash-register/withdrawal",
};

export const fetchCashRegister = createAsyncThunk(
  "cashRegister/fetchCashRegister",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.cashRegister, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const createCashRegister = createAsyncThunk(
  "cashRegister/createCashRegister",
  async (cashRegisterData: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoint.cashRegisterOpen,
        cashRegisterData,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const patchCashClose = createAsyncThunk(
  "cashRegister/patchCashClose",
  async (id: number, thunkAPI) => {
    try {
      const response = await axiosInstance.patch(
        `${endpoint.cashRegisterClose}/${id}`,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const patchCashChange = createAsyncThunk(
  "cashRegister/patchCashChange",
  async (data: any, thunkAPI) => {
    try {
      const { id, ...body } = data;
      const response = await axiosInstance.patch(
        `${endpoint.cashRegisterChange}/${id}`,
        { ...body },
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const patchCashWithdrawal = createAsyncThunk(
  "cashRegister/patchCashWithdrawal",
  async (data: any, thunkAPI) => {
    try {
      const { id, ...body } = data;
      const response = await axiosInstance.patch(
        `${endpoint.cashRegisterWithdrawal}/${id}`,
        { ...body, cash_register_id: id },
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
